/** A pilot's picture, or their initials (F413). */
export function Avatar({ handle, name, url, large }: { handle: string; name?: string | null; url?: string | null; large?: boolean }) {
  const source = (name && name.trim()) || handle;
  // The first letter of the first two words; a word without a letter or
  // a digit ("(e2e)") is skipped.
  const initials = source
    .split(/[\s._-]+/)
    .map((w) => w.replace(/[^\p{L}\p{N}]/gu, ""))
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join("");
  return (
    <span className={`avatar ${large ? "avatar-lg" : ""}`} aria-hidden="true">
      {url ? <img src={url} alt="" /> : initials || "?"}
    </span>
  );
}
